import { render } from "./Cabin.vue?vue&type=template&id=267c1722&scoped=true"
import script from "./Cabin.vue?vue&type=script&lang=js"
export * from "./Cabin.vue?vue&type=script&lang=js"

import "./Cabin.vue?vue&type=style&index=0&id=267c1722&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267c1722"]])

export default __exports__